<template>
  <ux-modal
    class="purchase-api"
    width="760px"
    :title="$t('HT.purchaseApi.title')"
    hideBtn
    v-model="showModal"
    :close="close"
  >
    <div class="purchase-api-cont">
      <!-- 进度条 -->
      <ux-steps :active="step">
        <ux-step v-for="item in stepList" :key="item" :title="item"></ux-step>
      </ux-steps>

      <!-- 第一步 -->
      <div class="purchase-step1" v-if="step === 1">
        <p class="purchase-step1-title">{{ product.product_name }}</p>
        <p class="purchase-step1-intro">{{ productRemark }}</p>

        <!-- 服务选择 -->
        <purchase-boxs
          class="purchase-step1-purchaseboxs"
          :list="serverList"
          @click="handleClickPurchaseServer"
        ></purchase-boxs>

        <!-- 有效期 -->
        <p class="purchase-step1-indate">
          <span>{{ $t('HT.addLicense.expireDate') }}:</span
          >{{ $t('HT.purchaseApi.text', {day: step1Indate}) }}
        </p>

        <!-- 价格 -->
        <p class="purchase-price">
          <span class="purchase-price-txt"
            >{{ $t('HT.purchaseApi.price') }}:<span class="purchase-price-unit">￥</span></span
          ><span class="purchase-price-allprice">{{ price }}</span>
        </p>

        <!-- 提示 -->
        <p class="purchase-tips">
          {{ $t('HT.purchaseApi.tips.left') }}
          <span>{{ $t('HT.purchaseApi.tips.center') }}</span> {{ $t('HT.purchaseApi.tips.right') }}
        </p>

        <ux-button class="btn-purchase" type="primary" size="large" @click="handleClickPurchase">{{
          $t('HT.purchaseApi.buy')
        }}</ux-button>
      </div>

      <!-- 第二步 -->
      <div class="purchase-step2" key="purchasestep2" v-if="step === 2">
        <p class="purchase-step2-title">{{ $t('HT.purchaseApi.payType') }}</p>
        <purchase-boxs
          class="purchase-step2-purchaseboxs"
          :list="payList"
          @click="handleClickPayType"
        ></purchase-boxs>

        <!-- 二维码 -->
        <div class="purchase-qrbox">
          <!-- 订单关闭 -->
          <template v-if="isError">
            <default-graph class="purchase-qrimg" type="9" v-if="isError"></default-graph>
            <p class="purchase-qrbox-tips">
              {{ $t('HT.purchaseApi.code') }} <span>{{ $t('HT.purchaseApi.invalid') }}</span>
            </p>
          </template>

          <!-- 订单正常 -->
          <template v-else>
            <div class="purchase-qrimg" ref="refQrcode" id="purchase-qrimg"></div>

            <p class="purchase-qrbox-tips">
              {{ $t('HT.purchaseApi.qrboxTips.left') }} <span>{{ countDownTxt }}</span>
              {{ $t('HT.purchaseApi.qrboxTips.right') }}
            </p>
          </template>
        </div>

        <!-- 价格 -->
        <p :class="['purchase-price', { 'purchase-price-error': isError }]">
          <span class="purchase-price-txt"
            >{{ $t('HT.purchaseApi.orderPrice') }}:<span class="purchase-price-unit">￥</span></span
          ><span class="purchase-price-allprice">{{ price }}</span>
        </p>

        <!-- 提示 -->
        <p class="purchase-tips">
          <template v-if="isError">
            {{ $t('HT.purchaseApi.error') }}
          </template>
          <template v-else>
            {{ $t('HT.purchaseApi.purchaseTips.left') }}
            <span>{{ $t('HT.purchaseApi.purchaseTips.center') }}</span
            >{{ $t('HT.purchaseApi.purchaseTips.right') }}
          </template>
        </p>
      </div>

      <!-- 第三步 -->
      <div class="purchase-step3" v-if="step === 3" key="purchasestep3">
        <div class="purchase-result">
          <div class="purchase-result-cont">
            <!-- 价格 -->
            <p class="purchase-price">
              <span class="purchase-price-txt"
                >{{ $t('HT.purchaseApi.orderPrice') }}:<span class="purchase-price-unit"
                  >￥</span
                ></span
              ><span class="purchase-price-allprice">{{ price }}</span>
            </p>
            <i class="purchase-step3-line"></i>

            <!-- 详情 -->
            <div class="purchase-result-details" v-for="item in resultList" :key="item.label">
              <div class="purchase-result-item">
                <p class="purchase-result-item-lable">{{ item.label }}</p>
                <p class="purchase-result-item-txt">{{ item.txt }}</p>
              </div>

              <i v-if="item.hasLine" class="purchase-step3-line"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ux-modal>
</template>

<script>
import PurchaseBoxs from '@c/purchaseBoxs/purchaseBoxs';
import DefaultGraph from '@c/defaultGraph/defaultGraph';
import QRCode from 'qrcodejs2';
import moment from 'moment';

export default {
  name: 'PurchaseApi',
  components: {
    PurchaseBoxs,
    DefaultGraph
  },
  props: {
    // 产品信息
    product: {
      type: Object,
      default: () => {
        return {};
      }
    },
    // 订单id
    orderId: {
      type: String,
      default: ''
    },
    // 订单价格
    orderPrice: {
      type: Number,
      default: 0
    },
    // 倒计时时间
    deadTime: {
      type: Number,
      default: 30 * 60 // 半小时
    },
    // 产品描述
    productRemark: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      qrcode: null,
      showModal: false,
      step: 1, // 第几步
      payTypeOption: this.$opt.payType, // 支付方式下拉框
      currentServer: null, // 当前选中的服务
      currentPayType: 0, // 当前选中的支付类型
      stepList: [
        this.$t('HT.purchaseApi.step1'),
        this.$t('HT.purchaseApi.step2'),
        this.$t('HT.purchaseApi.step3')
      ],
      timer: null,
      orderNo: '', // 订单编号
      isError: false, // 是否支付出错
      step1Indate: moment().add(365, 'days').format('YYYY/MM/DD'), // 有效期
      countDown: {
        countDownNum: 30 * 60, // 半小时
        timer: null
      },
      // 服务列表
      serverList: [],
      // 支付方式
      payList: [
        {
          label: this.$t('HT.options.payType1'),
          txt: this.$t('HT.options.payTxt'),
          isChecked: true,
          key: '0',
          value: 0
        },
        {
          label: this.$t('HT.options.payType2'),
          txt: this.$t('HT.options.payTxt'),
          isChecked: false,
          key: '1',
          value: 1
        },
        {
          label: this.$t('HT.options.payType3'),
          txt: this.$t('HT.options.payTxt2'),
          isChecked: false,
          key: '2',
          value: 2,
          disabled: true
        }
      ],
      // 结果数据
      resultList: []
    };
  },
  created() {
    if (!this.orderId) {
      this.getRuleList();
    }
    this.$nextTick(() => {
      this.showModal = true;
      // 要等动画结束
      this.$nextTick(() => {
        this.judgePaying();
      });
    });
  },
  destroyed() {
    this.clearTimer();
    this.countDownEnd();
  },
  computed: {
    price() {
      return this.formatNumber(this.orderPrice || this.currentServer?.money || 0);
    },
    // 格式化时间
    countDownTxt() {
      const num = this.countDown.countDownNum;
      const mStr = String(Math.floor(num / 60));
      const sStr = String(num % 60);
      const m = mStr.length > 1 ? mStr : '0' + mStr;
      const s = sStr.length > 1 ? sStr : '0' + sStr;
      return `00:${m}:${s}`;
    }
  },

  methods: {
    // 获取规则列表
    getRuleList() {
      this.$uxLoading.show();
      this.$api.myline.getRuleList(this.product.id).then((res) => {
        if (res.code == 10000) {
          const data = res.data || [];
          const serverList = data.map((item) => {
            const { count, id } = item;
            return {
              label: count / 10000,
              txt: this.$t('HT.purchaseApi.unit'),
              key: `server${id}`,
              isChecked: false,
              ...item
            };
          });
          serverList[0].isChecked = true;
          this.$set(this, 'serverList', serverList);
          this.currentServer = serverList[0];
        }
      });
    },
    /**
     * 关闭弹窗
     */
    close() {
      this.showModal = false;
      let timer = setTimeout(() => {
        clearTimeout(timer);
        timer = null;
        this.$emit('close');
      }, 500);
    },

    /**
     * 选择服务
     */
    handleClickPurchaseServer(item, idx) {
      if (item.isChecked) return;
      const serverList = this.serverList.map((serverItem, index) => {
        const res = serverItem;
        if (idx === index) {
          res.isChecked = !res.isChecked;
        } else {
          res.isChecked = false;
        }
        return res;
      });
      this.$set(this, 'serverList', serverList);
      this.currentServer = item;
    },

    /**
     * 选择支付类型
     */
    handleClickPayType(item, idx) {
      const payList = this.payList.map((payItem, index) => {
        const res = payItem;
        if (idx === index) {
          res.isChecked = !res.isChecked;
        } else {
          res.isChecked = false;
        }
        return res;
      });
      this.currentPayType = item.value;
      this.$set(this, 'payList', payList);
      this.$nextTick(() => {
        this.getOrderQrcode();
      });
    },

    /**
     * 点击购买 创建订单
     */
    handleClickPurchase() {
      const { product_id, money, id } = this.currentServer;
      const params = {
        discount_money: money, // 折扣价格
        product_id: product_id, // 产品id
        rule_id: id // 规格id
      };
      this.$uxLoading.show();
      this.$api.product.createOrder(params).then((res) => {
        if (res.code == 10000) {
          this.orderNo = res.data;
          this.gotoPay();
        }
      });
    },

    /**
     * 获取二维码
     */
    getOrderQrcode() {
      if (!this.$refs.refQrcode) return;
      this.$uxLoading.show();
      this.$api.product
        .getOrderQrcode(this.orderNo, {
          payType: this.currentPayType
        })
        .then((res) => {
          if (res.code == 10000) {
            if (!this.$refs.refQrcode) return;

            if (this.qrcode) {
              this.qrcode.clear();
              this.qrcode.makeCode(res.data);
              return;
            }
            this.qrcode = new QRCode('purchase-qrimg', {
              text: res.data,
              width: 200,
              height: 200
            });
          }
        });
    },
    /**
     * 获取订单状态
     */
    getOrderStatus() {
      const config = {
        config: true,
        hideMsg: true
      };
      this.$api.product.getOrderStatus(this.orderNo, config).then((res) => {
        if (!this.timer) return;
        if (res.code == 10000) {
          const data = res.data || {};
          const { status } = data;
          if (status === 1) {
            // 完成
            const { order_no, created_date, pay_date, pay_type, rule_count, product_name } = data;

            // 产品规格
            const count = this.formatNumber(rule_count / 10000);

            // 支付类型
            const payType =
              this.payTypeOption.find((item) => {
                return item.value === pay_type;
              })?.label || '';

            // 有效期
            const indate = moment(pay_date).add(365, 'days').format('YYYY/MM/DD');

            this.resultList = [
              { label: this.$t('orderNo'), txt: order_no },
              { label: this.$t('createdDate'), txt: created_date },
              { label: this.$t('payDate'), txt: pay_date },
              { label: this.$t('payType'), txt: payType, hasLine: true },
              { label: this.$t('productName'), txt: product_name },
              { label: this.$t('productRule'), txt: `${count}${this.$t('HT.purchaseApi.unit')}` },
              { label: this.$t('indate'), txt: indate }
            ];

            this.clearTimer();
            this.step = 3;
            this.$emit('update-list');
          } else if (status === 4) {
            // 关闭
            this.orderError();
          }
        }
      });
    },

    /**
     * 订单关闭
     */
    orderError() {
      this.clearTimer();
      this.isError = true;
      this.payList.forEach((payItem) => {
        payItem.isChecked = false;
        payItem.disabled = true;
      });
    },
    /**
     * 轮询获取订单状态
     */
    loopGetOrderStatus() {
      this.timer = setInterval(() => {
        this.getOrderStatus();
      }, 3000);
      this.getOrderStatus();
    },

    /**
     * 判断是否有订单号 有就直接第二步
     */
    judgePaying() {
      if (this.orderId) {
        this.orderNo = this.orderId;
        this.gotoPay();
      }
    },

    /**
     * 跳到第二步
     */
    gotoPay() {
      this.step = 2;
      this.$nextTick(() => {
        this.loopGetOrderStatus(); // 轮询获取状态
        this.getOrderQrcode();
        this.countDownStart();
      });
    },

    /**
     * 每三位数加逗号
     */
    formatNumber(num) {
      if (Number(num) > 0) {
        return this.$formatNumber(num);
      }
      return 0;
    },

    /**
     * 清除定时器
     */
    clearTimer() {
      clearInterval(this.timer);
      this.timer = null;
    },
    /**
     * 倒计时开始
     */
    countDownStart() {
      this.countDownEnd();
      this.countDown.countDownNum = this.deadTime;
      this.countDown.timer = setInterval(() => {
        if (this.countDown.countDownNum > 0) {
          this.countDown.countDownNum--;
        } else {
          this.orderError();
          this.countDownEnd();
        }
      }, 1000);
    },
    /**
     * 倒计时结束
     */
    countDownEnd() {
      clearInterval(this.countDown.timer);
      this.countDown.timer = null;
    }
  }
};
</script>

<style lang="scss" scoped>
.purchase-api-cont {
  position: relative;
  width: 600px;
  padding: 40px 0 44px;
  margin: 0 auto;

  .ux-steps {
    margin-bottom: 40px;
  }

  .purchase-step1 {
    .purchase-step1-title {
      height: 34px;
      font-size: 18px;
      font-weight: 600;
      color: $color-title;
      line-height: 24px;
    }

    .purchase-step1-intro {
      font-size: 14px;
      font-weight: 400;
      color: $color-text;
      line-height: 20px;
      padding-bottom: 32px;
    }

    .purchase-step1-purchaseboxs {
      margin-bottom: 4px;
    }

    .purchase-step1-indate {
      height: 44px;
      font-size: 14px;
      font-weight: 400;
      color: $color-text;
      line-height: 20px;
      border-bottom: 1px solid $color-disable;

      span {
        font-weight: 600;
        color: $color-title;
        padding-right: 10px;
      }
    }

    .purchase-tips {
      margin-bottom: 24px;
    }

    .purchase-price {
      margin-bottom: 10px;
    }
  }

  .purchase-step2 {
    .purchase-step2-title {
      height: 40px;
      font-size: 14px;
      font-weight: 600;
      color: $color-title;
      line-height: 20px;
    }

    .purchase-step2-purchaseboxs {
      margin-bottom: 36px;
    }

    .purchase-qrbox {
      height: 270px;
    }

    .purchase-qrimg {
      display: block;
      width: 200px;
      height: 200px;
      margin: 0 auto 10px;
    }

    .purchase-qrbox-tips {
      font-size: 14px;
      font-weight: 400;
      color: $color-text;
      line-height: 20px;
      margin-bottom: 24px;
      text-align: center;

      span {
        color: $color-error;
      }
    }

    .purchase-price {
      margin-bottom: 10px;

      &.purchase-price-error {
        .purchase-price-txt,
        .purchase-price-unit,
        .purchase-price-allprice {
          color: $color-text-disable;
        }
      }
    }
  }

  .purchase-step3 {
    .purchase-result {
      position: relative;
      width: 540px;
      margin: 0 auto;

      &::before,
      &::after {
        content: '';
        position: absolute;
        left: 0;
        width: 100%;
      }

      &::before {
        top: 0;
        height: 38px;
        background: url('~@/assets/images/web/img-pay-top.png') no-repeat center top / 100% auto;
      }

      &::after {
        bottom: -16px;
        height: 34px;
        background: url('~@/assets/images/web/img-pay-foot.png') no-repeat center top / 100% auto;
      }
    }

    .purchase-result-cont {
      box-sizing: border-box;
      margin: 0 auto;
      width: 520px;
      padding: 64px 30px 16px;
      box-shadow: 0px 2px 6px 0px $color-box-shadow;
    }

    .purchase-price {
      justify-content: space-between;
      align-items: baseline;

      .purchase-price-txt {
        font-size: 18px;
        flex: 1;
        justify-content: space-between;
      }

      .purchase-price-allprice {
        flex: 0 0 auto;
      }
    }

    .purchase-step3-line {
      display: block;
      width: 100%;
      height: 0;
      border-bottom: 1px dashed $color-disable;
      margin: 14px 0 24px;
    }

    .purchase-result-details .purchase-step3-line {
      margin: 8px 0 24px;
    }

    .purchase-result-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 14px;
      padding-bottom: 16px;
    }

    .purchase-result-item-lable {
      width: 180px;
      text-align: left;
      font-weight: 400;
      color: $color-text-secondary;
      line-height: 20px;
    }

    .purchase-result-item-txt {
      text-align: right;
      width: 260px;
      font-weight: 400;
      color: $color-text;
      line-height: 20px;
    }
  }

  .purchase-price {
    box-sizing: border-box;
    display: flex;
    align-items: center;

    .purchase-price-txt {
      display: flex;
      align-items: center;
      font-weight: 600;
      color: $color-title;
      font-size: 14px;
      line-height: 20px;
      height: 20px;
      padding-right: 8px;
    }

    .purchase-price-unit {
      font-size: 12px;
      font-weight: 400;
      color: $color-text;
      line-height: 20px;
      padding-left: 10px;
    }

    .purchase-price-allprice {
      height: 46px;
      font-size: 32px;
      font-weight: 900;
      color: $color-primary;
      line-height: 46px;
    }
  }

  .purchase-tips {
    font-size: 14px;
    font-weight: 400;
    color: $color-text;
    line-height: 20px;

    span {
      font-size: 14px;
      font-weight: 600;
      line-height: 20px;
    }
  }
}
</style>
